import gql from 'graphql-tag';

export const MUTATION_RUN_EQUIPMENT_COUNTING_JOURNAL_VARIANCE = gql`
  mutation runEquipmentCountingJournalVariance($id: String!) {
    runEquipmentCountingJournalVariance(id: $id) {
      id
      journalNum
      status
      lineCount
      countedCount
    }
  }
`;